import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { CustomerAnalyticsFilter } from "../../components/Reports/CustomerAnalytics/CustomerAnalyticsFilter";
import { DemographicsPie, ProductsPie } from "../../components/Reports/CustomerAnalytics/CustomerPieChart";
import { CustomersChart } from "../../components/Reports/CustomerAnalytics/CustomersChart";
import { Page } from "../Page";

export const CustomerAnalyticsPage = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push("/reports/customerAnalytics");
    };

    return (
        <Page title="Customer Analytics">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Customer Analytics</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <CustomerAnalyticsFilter />
                    <div className="flex h-full w-full flex-col px-6 py-3">
                        <div className="mb-6 w-full">
                            <CustomersChart />
                        </div>
                        <div className="grid grid-cols-3">
                            <DemographicsPie />
                            <ProductsPie />
                        </div>
                    </div>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
